import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  IonModal,
  ModalController,
  NavParams,
  IonicModule,
} from '@ionic/angular';
import { ModalDrawService } from './modal-draw.service';
import { Subscription, tap } from 'rxjs';
import { DrawPozoComponent } from './draw-pozo/draw-pozo.component';
import { DrawTomaComponent } from './draw-toma/draw-toma.component';
import { DrawHidranteComponent } from './draw-hidrante/draw-hidrante.component';

@Component({
  selector: 'app-create-modal',
  templateUrl: './create-modal.component.html',
  styleUrls: ['./create-modal.component.css'],
  imports: [
    IonicModule,
    DrawHidranteComponent,
    DrawTomaComponent,
    DrawPozoComponent,
  ],
})
export class CreateModalComponent implements AfterViewInit, OnDestroy {
  tipo: string;
  geojson: any;
  name: string;
  formSubscription: Subscription;
  formValid = false;
  titulo = 'Crear';

  get att() {
    return this.geojson.id ? this.geojson : undefined;
  }

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private modalService: ModalDrawService
  ) {
    this.tipo = this.navParams.get('tipo');
    this.geojson = this.navParams.get('geojson');
    this.formSubscription = this.modalService.validForm
      .pipe(
        tap(res => {
          this.formValid = res;
          console.log(this.formValid);
        })
      )
      .subscribe();
    if (this.geojson.id) {
      this.titulo = 'Editar';
    }
  }

  ngAfterViewInit(): void {}

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  confirm() {
    this.modalService.confirmButton.next(this.geojson);
    //
  }

  confirmComplete(event) {
    return this.modalCtrl.dismiss(this.name, 'confirm');
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.formSubscription.unsubscribe();
  }
}
